import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { adminApi, errMsg } from "@/lib/api";
import { Btn, Panel } from "@/admin/ui";

export const ChangePasswordPanel = () => {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const mismatch = f.confirm && f.confirm !== f.new_password;
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await adminApi.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password changed. Other devices have been signed out.");
      setF({ current_password: "", new_password: "", confirm: "" });
    } catch (er) { toast.error(errMsg(er)); } finally { setBusy(false); }
  };
  const field = (k, label, ac) => (
    <label className="block">
      <span className="text-xs font-semibold text-stone-600">{label}</span>
      <Input type="password" autoComplete={ac} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="h-10 bg-white mt-1" data-testid={`change-pw-${k}`} />
    </label>
  );
  return (
    <Panel title="Change admin password" className="mt-6" testId="change-password-panel">
      <form onSubmit={save} className="grid sm:grid-cols-3 gap-3 items-end">
        {field("current_password", "Current password", "current-password")}
        {field("new_password", "New password (min 8)", "new-password")}
        {field("confirm", "Repeat new password", "new-password")}
        {mismatch && <p className="text-xs text-accent sm:col-span-3" data-testid="change-pw-mismatch">New passwords don't match.</p>}
        <Btn disabled={busy || !f.current_password || f.new_password.length < 8 || f.confirm !== f.new_password} data-testid="change-pw-submit">{busy ? "Saving…" : "Change password"}</Btn>
      </form>
    </Panel>
  );
};
